//  libraries
import React from 'react'
import ListTemplate from 'components/common/listTemplate'

function Shipment () {
  return <ListTemplate isShipmentList />
}

export default Shipment
